export function createDefaultItemComponent(_ref) {
  var createElement = _ref.createElement,
    Fragment = _ref.Fragment;
  return function DefaultItem(userProps) {
    return createElement(Fragment, null, JSON.stringify(userProps.item, null, 2));
  };
}